import React from 'react';

import { Dropdown } from '@cambridgeassessment/cambridge-ui';
import { StyledInputContainer } from '../../Content.styles';

import {
  CentralModalStyled,
  FixedHeightModalContent,
  MaxLengthDisclaimer,
  ModalSubtitleStyled,
  ModalTitleStyled,
  StyledTextarea,
} from '../ManageSampleChanges.styles';
import { AlgoRerunSelect, reasonsSelectValues, resolveRerunReasonText } from './helpers';
import { RerunReason, RerunReasonsEnum } from '@cambridgeassessment/lib-ee-commons';

interface Props {
  onCloseClick: () => void;
  rerunReason: RerunReason | undefined;
  setRerunReason: (val: RerunReason | undefined) => void;
  onSubmit: () => void;
}

export const AlgoRerunModal = (props: Props): JSX.Element => {
  const { onCloseClick, rerunReason, setRerunReason, onSubmit } = props;

  const renderReason = (item: AlgoRerunSelect): string => item.val;

  const onReasonChange = (val: AlgoRerunSelect): void => setRerunReason({ ...rerunReason, type: val.key });

  const MAX_TEXTAREA_LENGTH = 200;

  const reasonTooLong = rerunReason?.otherReason != null && rerunReason?.otherReason.length > MAX_TEXTAREA_LENGTH;

  const isTextareaValueValid =
    rerunReason?.otherReason != null && rerunReason.otherReason.trim().length > 0 && !reasonTooLong;

  const isSubmitDisabled = !rerunReason || (rerunReason.type === RerunReasonsEnum.OTHER && !isTextareaValueValid);

  const defaultSelectValue = rerunReason
    ? {
        key: rerunReason.type,
        val: resolveRerunReasonText(rerunReason.type),
      }
    : null;

  return (
    <CentralModalStyled
      open
      dataQaId='algo-rerun-modal'
      btnRightText='Re-run sampling selection'
      btnLeftText='Cancel'
      onClickBtnRight={onSubmit}
      onClickBtnLeft={onCloseClick}
      btnRightDisabled={isSubmitDisabled}
    >
      <FixedHeightModalContent>
        <ModalTitleStyled data-qa-id='re-run-sample-title'>Re-run sample selection</ModalTitleStyled>
        <ModalSubtitleStyled data-qa-id='re-run-sample-subtitle'>
          Please choose the reason for the selection being re-run.
        </ModalSubtitleStyled>

        <StyledInputContainer fullWidth>
          <Dropdown<AlgoRerunSelect>
            data={reasonsSelectValues}
            renderOption={renderReason}
            renderSelectedOption={renderReason}
            dataQaId='rerun-reason-select'
            onChange={onReasonChange}
            value={defaultSelectValue}
            placeholder='Please choose a reason'
            title='Select reason'
          />
        </StyledInputContainer>

        {rerunReason?.type === RerunReasonsEnum.OTHER && (
          <>
            <ModalSubtitleStyled>Please enter the reason:</ModalSubtitleStyled>
            <StyledTextarea
              data-qa-id='other-reason-textarea'
              value={rerunReason.otherReason}
              onChange={(event) => {
                setRerunReason({ ...rerunReason, otherReason: event.target.value });
              }}
            />

            <MaxLengthDisclaimer data-qa-id='max-characters-text' warning={reasonTooLong}>
              Max. 200 characters
            </MaxLengthDisclaimer>
          </>
        )}
      </FixedHeightModalContent>
    </CentralModalStyled>
  );
};
